import * as React from 'react';

import {CodeBlock} from 'shells/code-block/code-block';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Modal} from 'shells/modal/modal';
import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {useGetChatSettings} from '../graphql/hooks';

import {EnableChatSwitch} from './buttons';
import {EmbedChatStep} from './buttons/embed-chat-step';

export function EmbedChatModal() {
    const {chatSettings, isLoading, refetch} = useGetChatSettings();
    const {isOpen, onClose} = useOpenableModal(OpenableModals.EMBED_CHAT_MODAL);

    return (
        <Modal
            isOpen={isOpen}
            canClickOutsideToClose={true}
            onClose={onClose}
            // @ts-expect-error
            fitContent={true}
            maxHeight={chatSettings && !chatSettings.isChatEnabled ? 700 : 600}
        >
            <div className='pb-32'>
                <ModalHeader>Embed this chat flow onto your website</ModalHeader>
                <StackLegacy spacing={16}>
                    {chatSettings && !chatSettings.isChatEnabled && (
                        <FlashBanner type='info'>
                            <div className='flex flex-dir-col full-width'>
                                <Body size='normal' isBold={true} color='blue'>
                                    Chat is currently off, so you can safely embed it on your site.
                                </Body>
                                <Body size='normal' color='blue'>
                                    When you’re ready to enable chat, turn it on in Nutshell.
                                </Body>
                            </div>
                        </FlashBanner>
                    )}
                    <EmbedChatStep
                        stepHeading='Step 1:'
                        stepBody={
                            <>
                                Copy and paste this code snippet into the{' '}
                                <strong>&lt;head&gt;</strong> wherever you’d like this chat to
                                appear on your website.
                            </>
                        }
                    />
                    {isLoading && !chatSettings ? (
                        <LoadingIcon />
                    ) : (
                        <CodeBlock
                            value={
                                chatSettings
                                    ? chatSettings.embedScript
                                    : 'Sorry, no embed script found'
                            }
                            includeCopyButton={true}
                            height={205}
                            label='Embed code'
                            name='embedCode'
                        />
                    )}
                    <EmbedChatStep
                        stepHeading='Step 2:'
                        stepBody='Configure your visitor’s chat experience in chat settings. There, you can customize the chat’s appearance and behaviors to align with your company’s brand identity.'
                    />
                    <EmbedChatStep
                        stepHeading='Step 3:'
                        stepBody='Last step is to make your chat visible for your website visitors. If you plan to make changes to your chat flow, we recommend turning the chat off beforehand.'
                    />
                    <EnableChatSwitch
                        // @ts-expect-error
                        isChatEnabledOnWebsite={chatSettings ? chatSettings.isChatEnabled : false}
                        refetchSettings={refetch}
                    />
                </StackLegacy>
            </div>
        </Modal>
    );
}
